import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const VideoQuality = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('monitor_item2'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px' }}>{t('video_quality_faq')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}video_quality.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
        </div>
    </div>
}

export default VideoQuality